<script setup lang="ts">
import {onMounted, ref} from "vue";
import {label} from "../../mixins/translations";
import {useCartStore} from "../../stores/cart";

const open = ref(false);
const cartStore = useCartStore();

const afterAdding = () => {
    open.value = true;
}

onMounted(() => {
    cartStore.events.on('afterAdding', afterAdding);
});
</script>
<template>
    <Modal :open="open !== false" @updateOpen="open = !open;">
        <template #trigger-wrapper>&nbsp;</template>
        <template #title>
            <div class="w-full">
                <div class="text-xl w-full text-secondary-700 font-bold text-center">{{ label('site.product.popup.title') }}</div>
            </div>
        </template>
        <template #description>
            <div class="paragraph text-base font-normal text-black text-center mt-3">{{ label('site.product.popup.content') }}</div>

            <div class="flex mt-4 gap-x-4 text-center justify-center">
                <button @click.prevent="open = false;"
                        class="h-10 px-5 cursor-pointer flex items-center justify-center text-white bg-primary hover:bg-primary-700 transition-all duration-500 z-20">
                    <span>{{ label('site.product.popup.continue_shopping') }}</span>
                </button>
                <a href="/cart/"
                        class="h-10 px-5 pointer font-medium flex items-center justify-center text-white bg-secondary-500 hover:bg-secondary-700 transition-all duration-500">
                    {{ label('site.product.popup.cart') }}
                </a>
            </div>
        </template>
    </Modal>
</template>
